// extracted by mini-css-extract-plugin
export default {"button-secondary":"ButtonSecondary_button-secondary__DnEKz"};